import styled from 'styled-components'

export const PdfContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: scroll;

  justify-content: center;
  align-items: center;

  .pdf__container {
    max-height: 500px;
    overflow: scroll;
  }
`

export const ButtonsContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;

  .nohover:not(.fix-hover):hover {
    background-color: var(--button-background-color);
  }
`

export const ReportContainerUs = styled.iframe`
  width: 100%;
  height: 100%;
  margin-bottom: 24px;
  border: none;
`
